var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7734 5.15625V8.82031H2.22656V5.15625C2.22656 4.75436 2.55124 4.42969 2.95312 4.42969H22.0469C22.4488 4.42969 22.7734 4.75436 22.7734 5.15625ZM2.22656 19.8438V10.8555H22.7734V19.8438C22.7734 20.2456 22.4488 20.5703 22.0469 20.5703H2.95312C2.55124 20.5703 2.22656 20.2456 2.22656 19.8438ZM15.6899 15.4297C15.5847 15.4297 15.4985 15.5158 15.4985 15.6211V17.2734C15.4985 17.3787 15.5847 17.4648 15.6899 17.4648H19.4766C19.5819 17.4648 19.668 17.3787 19.668 17.2734V15.6211C19.668 15.5158 19.5819 15.4297 19.4766 15.4297H15.6899Z",
    fill: "#C7C9C7",
    stroke: "#C7C9C7",
    strokeWidth: 0.015625
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.f1c92935.svg";
export { ForwardRef as ReactComponent };